import React, {Component} from "react"
import PropTypes from "prop-types"

import {H2, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import theme from "@irati/ui/src/global/theme"
import {adminDashboardTracking} from "@irati-tracking/admin"
import History from "@irati/utils/history"

import {FlexGrowCard} from "./styled"
import {SETTINGS_LOGIN_INTEGRATION} from "../../../routes/routeConfig"

interface Props {
  title: string
  text: string
  isSSO?: boolean
}

interface State {}

class InfoCard extends Component<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  handleClick = () => {
    const {isSSO} = this.props

    if (isSSO) {
      adminDashboardTracking.clickGetStartedSSO()
    } else {
      adminDashboardTracking.clickGetStartedDsync()
    }

    History.push(SETTINGS_LOGIN_INTEGRATION, this.context.apps.ADMIN)
  }

  render() {
    const {title, text} = this.props

    return (
      <FlexGrowCard bgColor={theme.colors.utility.highlight}>
        <H2 marginBottom={1}>
          <FormattedMessage id={title} />
        </H2>
        <Body marginBottom={2}>
          <FormattedMessage id={text} />
        </Body>
        <Button id="adminSection_integration_getStarted_button" primary onClick={this.handleClick}>
          <FormattedMessage id="admin.dashboard.integrations.card.button" />
          <Icon icon={IconTypes.circleArrowRight} marginLeft />
        </Button>
      </FlexGrowCard>
    )
  }
}

export default InfoCard
